import { render, staticRenderFns } from "./vehicleViolationDetail.vue?vue&type=template&id=2f37a442"
import script from "./vehicleViolationDetail.vue?vue&type=script&lang=js"
export * from "./vehicleViolationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports